import * as React from 'react';
if (process.env.BROWSER) {
    require('./index.less');
}
export interface ICommentLoadingProp {
    message: string;
}
export default class CommentLoading extends React.PureComponent<ICommentLoadingProp> {
    public render(): JSX.Element {
        return <div className={'comment-loading'}>{this.props.message}</div>;
    }
}
